<!-- eslint-disable max-lines -->
<template>
    <div class="customer-detail-page" :v-loading="detailLoading">
        <!-- <div class="registration-head"> -->
        <div class="customer-head-box">
            <div class="customer-head">
                <div class="customer-head-left">
                    <div class="customer-head-title">{{ detailDataLocal.customerName }}</div>
                    <div v-if="getCustomerStatus()"
                        :class="['customer-status', 'customer-' + detailDataLocal.customerStatus]">
                        {{ getCustomerStatus() }} </div>
                </div>
                <span class="customer-head-right">
                    <lots-button class="bigData-btn-customer-detail-save" type="primary" v-show="isShowBtn['save']" v-has="authorityCode.save"
                        @click="saveHeader" :disabled="showSaveBtn" :loading="saveLoading">保 存
                    </lots-button>
                    <lots-button class="bigData-btn-customer-detail-flow" type="primary" v-show="isShowBtn['flow']" v-has="authorityCode.flow"
                        @click="flowHeader" :loading="flowLoading">提交审批
                    </lots-button>
                    <!-- <lots-button type="primary" @click="saveHeader" :loading="saveLoading">保 存</lots-button>
                    <lots-button type="primary" @click="sumitFlowHeader" :loading="sumitFlowLoading">新建审批</lots-button> -->
                    <lots-button class="bigData-btn-customer-detail-infoChange" type="primary" v-show="isShowBtn['infoChange']" v-has="authorityCode.infoChange"
                        :loading="checkLoading.checkLoading2" @click="infoChangeHeader(2)">信息变更</lots-button>
                        <lots-button type="primary" v-show="isShowBtn['insertSup']" v-has="authorityCode.overseasIntroduction"
                        :loading="checkLoading.checkLoading4" @click="addOverseas">海外业务引入</lots-button>
                    <lots-button class="bigData-btn-customer-detail-statusChange" type="primary" v-show="isShowBtn['statusChange']" v-has="authorityCode.statusChange"
                        :loading="checkLoading.checkLoading3" @click="infoChangeHeader(3)">状态变更</lots-button>
                    <lots-button class="bigData-btn-customer-detail-insertSup" type="primary" v-show="isShowBtn['insertSup']" @click="insertSupHeader"
                        v-has="authorityCode.supplier" :loading="insertSupLoading">生成供应商</lots-button>
                    <lots-button class="bigData-btn-customer-detail-insertVir" type="primary" v-show="isShowBtn['insertVir']" v-has="authorityCode.virtual"
                        :loading="checkLoading.checkLoading1" @click="infoChangeHeader(1)">新建虚拟客户</lots-button>
                    <lots-button class="bigData-btn-customer-detail-asynGroup" type="primary" v-show="isShowBtn['asynGroup']" @click="asynGroupcHeader"
                        v-has="authorityCode.group" :loading="asyncGroupLoading">同步集团</lots-button>
                    <lots-button class="bigData-btn-customer-detail-asyncLaw" type="primary" v-show="isShowBtn['asyncLaw']" @click="asyncLawHeader"
                        v-has="authorityCode.law" :loading="asyncLawLoading">同步法务</lots-button>
                    <lots-button class="bigData-btn-customer-detail-xsyLink" type="primary" v-show="isShowBtn['xsyLink']" @click="openXsyLink"
                        v-has="authorityCode.xsyLink">跳转销售易</lots-button>
                    <!-- <lots-button type="primary" v-show="isShowBtn['updateBussiness']" @click="updateBussinessHeader"
                        :loading="updateBussinessLoading">更新工商信息</lots-button>
                    <lots-button type="primary" v-show="false" @click="getRiskLevelHeader"
                        :loading="getRiskLevelLoading">获取风险等级</lots-button>
                    <lots-button type="primary" v-show="isShowBtn['opsUnlock']" @click="opsUnlockHeader"
                        :loading="opsUnlockLoading">运维解锁</lots-button> -->
                    <!-- <lots-button type="primary" v-show="isShowBtn['opsSave']" @click="opsSaveHeader"
                        :loading="opsSaveLoading">运维保存</lots-button> -->

                    <lotsButton v-show="isShowMoreBtn" class="customer-head-more" type="primary" size="mini" title="更多">
                        <el-dropdown class="customers-manage-list-dropdown" trigger="hover" :append-to-body="false">
                            <span class="el-dropdown-link">
                                更多<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown" class="customers-manage-list-dropdown-menu">
                                <el-dropdown-item class="dropdown-item" v-show="isShowBtn['updateBussiness']"
                                    @click.native="updateBussinessHeader"
                                    v-has="authorityCode.icbu">更新工商信息</el-dropdown-item>
                                <el-dropdown-item class="dropdown-item" v-show="false" @click="getRiskLevelHeader"
                                    v-has="authorityCode.risk" :loading="getRiskLevelLoading">获取风险等级</el-dropdown-item>
                                <el-dropdown-item class="dropdown-item" v-show="isShowBtn['opsUnlock']"
                                    @click.native="opsUnlockHeader" :loading="opsUnlockLoading">运维解锁</el-dropdown-item>
                                <el-dropdown-item class="dropdown-item" v-show="isShowBtn['xiaoshouyiPush']"
                                    @click.native="xiaoshouyiPushHeader" v-has="authorityCode.xsyPush"
                                    :loading="xiaoshouyiPushLoading">销售易重推</el-dropdown-item>
                                <el-dropdown-item class="dropdown-item" v-show="isShowBtn['opsUpdate']" v-has="authorityCode.erpBtn"
                                    @click.native="opsUpdateHeader" >特权维护</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </lotsButton>
                    <el-tooltip class="item-flow-right" effect="dark" content="刷新" placement="bottom">
                        <lots-button size="mini" icon="el-icon-refresh" v-show="detailDataLocal.customerCode"
                            class="bigData-btn-customer-detail-refresh refresh" @click="refleshPage" :loading="detailLoading"></lots-button>
                    </el-tooltip>
                </span>
            </div>
            <div>
                <span v-if="detailDataLocal.isVirtualCustomer === 'Y' && getVirtualCustomerStatus()"
                    :class="['customer-status', 'customer-' + detailDataLocal.isVirtualCustomer]">
                    {{ getVirtualCustomerStatus() }}
                </span>
            </div>
        </div>
        <!-- 表单区域 -->
        <collapse-infos class="infos-content customer-content-detail" ref="upholdHealder" :key="collapseKeys"
            :detailData="detailDataLocal" :collapse="COLLAPSE" :activeCollapses="activeCollapses" :addedDictKeys="addedDictKeys"
            @change="handleInfosChange">
            <!-- 表单字段插槽 -->
            <template v-slot:collapse-append="{ form, itemSetting, rIndex, collapseItem, dictData }">
                <span v-if="itemSetting.prop === 'industryType'">
                    <el-cascader v-if="industryTypeDisabled" class="customer-cascader-select" size="mini"
                        v-model="form[itemSetting.prop]" :options="industryData" :props="itemSetting.props"
                        collapse-tags :clearable="true" :filterable="true" :show-all-levels="false"
                        :checkStrictly="false" :placeholder="itemSetting.name"
                        @change="(data) => { customAppendChange(data, itemSetting.prop); }">
                    </el-cascader>
                    <span :title="formatIndustry()" v-else>{{ formatIndustry() }}</span>
                </span>

                <span class="customer-id-number" v-else-if="itemSetting.prop === 'idNumber'" :key="encryption[itemSetting.prop]">
                    <span> {{ encryptionHandle(form[itemSetting.prop], itemSetting.prop)|| '--'}}</span>
                        <img v-if="encryptionHandle(form[itemSetting.prop], itemSetting.prop)" :class="['text-eyes']" @click="handleChangeText(itemSetting)"
                            :src="encryption[itemSetting.prop] ? iconOpenEyes : iconCloseEyes" alt="">
                </span>
                <span v-else-if="['businessScope', 'ebcuRemark'].includes(itemSetting.prop)">
                    <span class="customer-text-area"
                        :title="(form[itemSetting.prop] || form[itemSetting.prop] === 0) ? form[itemSetting.prop] : '--'"
                        v-html="(form[itemSetting.prop] || form[itemSetting.prop] === 0) ? form[itemSetting.prop] : '--'"></span>
                </span>
                <span v-else-if="['addressCode'].includes(itemSetting.prop)" class="custom-span"
                    :title="formatAddress()">
                    <el-cascader v-if="addressCodeDisabled" class="address-custom" v-model="form[itemSetting.prop]"
                        @change="addressChange(form, itemSetting, 'change')" @visible-change="visibleChange" :key="cascaderKey" ref="customerAddressRef"
                        :props="itemSetting.props" :filterable="true" :filter-method="addressFilter" popper-class="address-popper-custom ">
                        <template slot-scope="{ node, data }">
                            <div class="cascader-custom" >
                                <el-tooltip class="item" :disabled="showTooltip" effect="light" :content="data.label"
                                    placement="top">
                                    <p @mouseenter="mouseenterHandle($event)">{{ data.label
                                        }}</p>
                                </el-tooltip>
                                <el-tooltip class="item" :disabled="showTooltip" effect="light" :content="formatCascaderData(data) ? data.nameLo : ''"
                                    placement="top">
                                    <p v-if="formatCascaderData(data)" @mouseenter="mouseenterHandle($event)">{{
                                        data.nameLo }}</p>
                                </el-tooltip>
                                <el-tooltip class="item" :disabled="showTooltip" effect="light" :content="formatCascaderData(data) ? data.nameEn : ''"
                                    placement="top">
                                    <p v-if="formatCascaderData(data)" @mouseenter="mouseenterHandle($event)">{{
                                        data.nameEn }}</p>
                                </el-tooltip>
                            </div>
                        </template>
                    </el-cascader>
                    <span :title="formatAddress()" v-else>{{ formatAddress() }}</span>
                </span>
                <span v-else-if="!itemSetting.optionsKey" class="custom-span" :title="form[itemSetting.prop]">
                    {{ form[itemSetting.prop] ? form[itemSetting.prop] : '--' }}
                </span>

            </template>
        </collapse-infos>
        <!-- 子页签组件 -->
        <el-collapse class="contract-collapse detail-more-collapse" value="moreInfo" @change="handleClickMoreInfo">
            <el-collapse-item title="更多信息" name="moreInfo" ref="tabs">
                <el-tabs v-model="activeName" @tab-click="handleClickTab">
                    <el-tab-pane label="联系人" name="contact" v-if="subTabShow.contact">
                        <contact-info ref="applyChangeRef" :detailData="detailDataLocal" :activeName="activeName">
                        </contact-info>
                    </el-tab-pane>
                    <el-tab-pane label="盖章人" name="stamper" v-if="subTabShow.stamper">
                        <customer-detail ref="stamperRef" :activeName="activeName" :detailPageState="detailPageState"
                            :detailData="detailDataLocal" :readonly="true">
                        </customer-detail>
                    </el-tab-pane>
                    <el-tab-pane label="业务实体" name="ebca" v-if="subTabShow.ebca">
                        <ebca-detail ref="ebcaRef" :activeName="activeName" :detailData="detailDataLocal">
                        </ebca-detail>
                    </el-tab-pane>
                    <el-tab-pane label="海外业务引入" name="overseasIntroduction" v-if="subTabShow.overseasIntroduction">
                        <overseas-list ref="overseasIntroductionRef" :activeName="activeName" :detailData="detailDataLocal">
                        </overseas-list>
                    </el-tab-pane>
                    <el-tab-pane label="虚拟客户明细" name="virtual" v-if="subTabShow.virtual">
                        <virtual-detail ref="virtualRef" :activeName="activeName" @db-click-open="openOtherCustomer"
                            :detailData="detailDataLocal">
                        </virtual-detail>
                    </el-tab-pane>
                    <el-tab-pane label="合同明细" name="contract" v-if="subTabShow.contract">
                        <contract-list ref="contractRef" :activeName="activeName" :detailData="detailDataLocal">
                        </contract-list>
                    </el-tab-pane>

                    <el-tab-pane label="变更列表" name="iflowDetail" v-if="subTabShow.iflowDetail">
                        <iflow-detail ref="iflowDetailRef" :detailData="detailDataLocal" :activeName="activeName">
                        </iflow-detail>
                    </el-tab-pane>
                    <el-tab-pane label="变更日志" name="history" v-if="subTabShow.history">
                        <history-list ref="filesDetailRef" :activeName="activeName" :detailData="detailDataLocal">
                        </history-list>
                    </el-tab-pane>
                    <el-tab-pane label="客户一页纸" name="paper" v-if="subTabShow.paper" lazy>
                        <customer-paper ref="customerPaperRef" :activeName="activeName" :detailData="originalData">
                        </customer-paper>
                    </el-tab-pane>
                    <el-tab-pane label="投标账号" name="biddingAccount" v-if="subTabShow.biddingAccount">
                        <bidding-account-list ref="biddingAccountRef" :activeName="activeName" :detailData="detailDataLocal">
                        </bidding-account-list>
                    </el-tab-pane>

                </el-tabs>
            </el-collapse-item>
        </el-collapse>
        <customer-erp-dialog ref="customerErpRef" />
        <span class="position-box"></span>
    </div>
</template>

<script>
import { ref, reactive, computed, onMounted, watch, nextTick, getCurrentInstance, onUnmounted } from '@vue/composition-api';
import lotsButton from '@/components/lots/lotsButton';
import collapseInfos from '@/modules/mdm/views/contractModules/components/collapseInfos/CollapseInfos.vue';
import { collapse, desensitization, addedDictKeys } from './collapseInfosConfig.js';

import {
    getIndustryTree
} from '@mdm/api/contractManage/contractRegistration.js';
import {
    getCustomerGroupTips, getCustomerByCode, customerSubmitFlow, getCustomerChangeFlowInfo,
    saveCustomer, insertSupCustomer, asyncGroupCustomer, asyncLawCustomer, updateBussinessCustomer,
    getRiskLevelCustomer, opsUnlockCustomer, saveCustomerPrivilegeVerify, xsyPush,
    checkStatusInfo, checkChangeInfo, checkVirtualInfo
} from '@/modules/mdm/api/customer/customerManage.js';
import { getCustomerIntroductionPage } from '@/modules/mdm/api/customer/customerIntroduction.js';
import { Message, MessageBox } from 'element-ui';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import _ from 'lodash';
import store from '@/store/index';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import contactInfo from '../component/contactInfo/Index.vue';
import iflowDetail from '../component/iflowDetail/Index.vue';
import virtualDetail from '../component/virtualDetail/Index.vue';
import historyList from '../component/historyList/Index.vue';
import biddingAccountList from '../component/biddingAccountList/Index.vue';
import EbcaDetail from '@/modules/mdm/views/customerModules/customerManage/component/ebca/Index.vue';
import CustomerDetail from '@/modules/mdm/views/customerModules/customerManage/component/stamper/Index.vue';
import contractList from '@/modules/mdm/views/customerModules/customerManage/component/contractList/Index.vue';
import overseasList from '@/modules/mdm/views/customerModules/customerManage/component/overseasList/Index.vue';
import customerPaper from '@/modules/mdm/views/customerModules/customerManage/component/customerPaper/Index.vue';
import customerErpDialog from '@/modules/mdm/views/customerModules/customerManage/component/customerErpDialog/Index.vue';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import configEnv from '@/config/user.env.js';
import Bus from '@/utils/bus.js';
// import addressSelector from '@/components/lots/addressSelector/index';
import { noChineseReg } from '@/modules/mdm/utils/regList.js';
import bigDataLog from '@/utils/bigDataLog.js';
import iconOpenEyes from '@/assets/images/icon-open-eyes.png';
import iconCloseEyes from '@/assets/images/icon-close-eyes.png';
const saveBtnApprovalStatus = ['10', '20']; // 客户的审批状态等于客户审批中:10/信息变更审批中:20时隐藏按钮，否则保持可见；

export default {
    name: 'detailPage',
    components: {
        lotsButton,
        collapseInfos,
        contactInfo,
        iflowDetail,
        EbcaDetail,
        historyList,
        contractList,
        CustomerDetail,
        virtualDetail,
        overseasList,
        customerPaper,
        customerErpDialog,
        biddingAccountList
    },
    props: {
        code: {
            type: String,
            default() {
                return '';
            }
        },
        detailData: {
            type: Object,
            default() {
                return {};
            }
        },
        detailPageState: {
            type: String,
            default() {
                return 'main';
            }
        },
        activeTabs: {
            type: String,
            default() {
                return '';
            }
        }

    },
    // eslint-disable-next-line max-lines-per-function
    setup(props, setupContext) {
        const config = _.cloneDeep(collapse);
        const activeCollapses = ref(['manageInfo', 'registerInfo', 'financeInfo', 'otherInfo']);
        const authorityCode = reactive(btnAuthority.customerManage);
        const { userCode } = store.getters.user;
        const detailDataLocal = ref({});
        const readonly = ref(false);

        const isShowMoreBtn = computed(() => {
            const { unlock, icbu } = btnAuthority.customerManage;
            const { ebcuId } = detailDataLocal.value;
            return ebcuId && (otherUtils.getHasAuth(unlock) || otherUtils.getHasAuth(icbu));
        });
        // eslint-disable-next-line complexity
        const subTabShow = computed(() => {
            const { isVirtualCustomer, existVirtual, ebcuId } = detailDataLocal.value;
            const currentAuth = {
                contact: otherUtils.getHasAuth(
                    btnAuthority.customerManage.contactTab
                ),
                stamper: otherUtils.getHasAuth(
                    btnAuthority.customerManage.stamperTab
                ) && isVirtualCustomer !== 'Y',
                ebca: otherUtils.getHasAuth(
                    btnAuthority.customerManage.ebcaTab
                ),
                overseasIntroduction: otherUtils.getHasAuth(
                    btnAuthority.customerManage.overseasIntroductionTab
                ),
                virtual: otherUtils.getHasAuth(
                    btnAuthority.customerManage.virtualTab
                ) && existVirtual, // 关联虚拟客户
                contract: otherUtils.getHasAuth(
                    btnAuthority.customerManage.contractTab
                ),
                iflowDetail: otherUtils.getHasAuth(
                    btnAuthority.customerManage.iflowDetailTab
                ),
                history: otherUtils.getHasAuth(
                    btnAuthority.customerManage.historyTab
                ),
                paper: true,
                biddingAccount: otherUtils.getHasAuth(
                    btnAuthority.customerManage.biddingAccountTab
                )
            };
            const currentListAuth = ['contact', 'stamper', 'ebca', 'overseasIntroduction', 'virtual', 'contract', 'iflowDetail', 'history', 'biddingAccount'];
            if (!ebcuId) {
                return currentAuth;
            }

            if (activeName.value === '1') {
                const firstTrueKey = _.findKey(currentAuth, value => value === true);
                activeName.value = firstTrueKey;
            } else if (!currentAuth[activeName.value]) {
                activeName.value = _.find(currentListAuth, key => currentAuth[key] === true);
            }

            return currentAuth;
        });
        const newPageStatus = computed(() => {
            return detailDataLocal.value.customerStatus?.toString() === '0';
        });
        // 行业大类判断是否编辑以及运维编辑
        const industryTypeDisabled = computed(() => {
            const { ebcuId, customerChannel, approvalStatus, customerStatus } = detailDataLocal.value;
            if (opsUnlockData.value.includes('industryType')) return true;
            if (ebcuId && String(customerChannel) === '2') return false;
            const appStatus = ['', null, undefined, '0', '00', '12'].includes(approvalStatus?.toString());
            return appStatus ? customerStatus?.toString() === '0' || opsUnlockData.value.includes('industryType') : false;
        });
        // 国家地址是否编辑以及运维编辑
        const addressCodeDisabled = computed(() => {
            const { ebcuId, customerChannel, approvalStatus, customerStatus } = detailDataLocal.value;
            if (opsUnlockData.value.includes('addressCode')) return true;
            if (ebcuId && String(customerChannel) === '2') return false;
            const appStatus = ['', null, undefined, '0', '00', '12'].includes(approvalStatus?.toString());
            // !['', null, undefined, '0', '00', '12'].includes(approvalStatus?.toString()
            return appStatus ? customerStatus?.toString() === '0' : false;
        });
        const getCustomerGroupTipsInfo = () => {
            return getCustomerGroupTips({
                customerName: detailDataLocal.value.customerName
            }).then(res => {
                if (res && +res.code === 0) {
                    res.data && Message.warning({
                        showClose: true,
                        message: '客户系相似：' + res.data,
                        type: 'warning'
                    });
                }
            }).finally(() => {
                ++initCustomerKey;
            });
        };
        let initCustomerKey = 1;
        const collapseKeys = computed(() => {
            // return _.sumBy(COLLAPSE.value, item =>
            //     (item.visible ? 1 : 0)
            //     + _.sumBy(item.formlist || [], formItem => formItem.visible ? 1 : 0)
            // );

            return COLLAPSE.value.filter(it => it.visible).length;
        });
        // const isShowOpsUnlockKey = ref(1);
        // const currentMonthSart = dayjs().startOf('month').valueOf(); // 获取当前时间的月份第一天时间戳
        // eslint-disable-next-line max-lines-per-function
        const COLLAPSE = computed(() => { // 配置项动态计算
            const { ebcuId, customerChannel, customerBodyType, isRelatedTransaction, isVirtualCustomer, mipStatus, approvalStatus,
                customerName, supplierCode, isImpExpCustomer
            } = detailDataLocal.value;
            // eslint-disable-next-line max-lines-per-function
            config.forEach((v, i) => {
                if (['financeInfo', 'otherInfo'].includes(v.formName) && !_.isNil(isVirtualCustomer)) {
                    v.visible = isVirtualCustomer === 'N';
                }

                // eslint-disable-next-line complexity, max-lines-per-function
                v.formList.forEach((v2, i2) => {
                    if (v2.prop === 'customerShortName') {
                        v2.type = isVirtualCustomer === 'N' && newPageStatus.value ? 'input' : 'custom'; // 非虚拟客户必填 isVirtualCustomer:1-虚拟 0-不虚拟
                        v2.disabled = !newPageStatus.value;
                    }
                    if (v2.prop === 'belongCustomerCode') {
                        v2.visible = isVirtualCustomer === 'Y'; // 是否虚拟客户等于是时显示，否则隐藏
                    }
                    if (v2.prop === 'customerGroupName') {
                        v2.rule[0].required = newPageStatus.value;
                        v2.type = newPageStatus.value ? 'advance' : 'custom';
                        v2.beforeRequest = params => {
                            initCustomerKey === 1 && getCustomerGroupTipsInfo();
                            params.alikeName = customerName;
                            params.enableFlag = 1;
                            return params;
                        };
                    }
                    if (['ebcuBuCode', 'ebcuCustomerType'].includes(v2.prop)) {
                        v2.type = newPageStatus.value ? 'select' : 'custom';
                        // 0 内销  2 内外销
                    }
                    if (['ebcuBuCode', 'ebcuCustomerType'].includes(v2.prop)) {
                        v2.visible = isVirtualCustomer !== 'Y';
                    }
                    if (['ebcuCustomerType'].includes(v2.prop)) {
                        v2.optionsKey = ['0', '2'].includes(isImpExpCustomer?.toString()) ? 'EBCU_CUSTOMER_TYPE' : 'EBCU_CUSTOMER_TYPE_OVERSEAS';
                    }
                    if (['customerOwnerName'].includes(v2.prop)) {
                        v2.type = newPageStatus.value ? 'advance' : 'custom';
                    }
                    if (['sinosureCode'].includes(v2.prop)) {
                        v2.visible = ['2'].includes(customerBodyType) || isVirtualCustomer === 'N';
                    }
                    if (['supplierCode'].includes(v2.prop)) {
                        // advance
                        v2.type = ['2', '3'].includes(String(customerChannel)) && newPageStatus.value ? 'advance' : 'custom';
                        v2.isOpenFetchFunc = () => {
                            return !supplierCode;
                        };
                    }
                    if (['industryType', 'customerChannel', 'ebcuBuCode', 'customerOwnerCode'].includes(v2.prop)) {
                        v2.rule[0].required = newPageStatus.value;
                    }

                    if (['customerChannelRole'].includes(v2.prop)) {
                        v2.rule[0].required = String(customerChannel) === '3';
                        v2.type = v2.rule[0].required && newPageStatus.value ? 'select' : 'custom';
                    }
                    if (['customerBodyType'].includes(v2.prop)) {
                        v2.rule[0].required = isVirtualCustomer === 'N';
                        v2.visible = isVirtualCustomer !== 'Y';
                    }
                    if (['societyCreditCode', 'ebcuTaxRegistNo'].includes(v2.prop)) {
                        v2.type = customerBodyType === '1' ? 'custom' : 'input'; // 客户控制类型为法人时，显示且只读；
                        // 客户控制类型为空/非法人时，隐藏且清空；
                        v2.visible = (customerBodyType === '1') && isVirtualCustomer !== 'Y';
                    }
                    if (['ebcuOrgBarcode', 'ebcuLegalEntity', 'tycAddress'].includes(v2.prop)) { // 组织机构代码/法人代表/注册地址
                        // 客户控制类型为空/非法人时，隐藏且清空；
                        v2.visible = (customerBodyType === '1') && isVirtualCustomer !== 'Y';
                    }
                    if (['ebcuBusinessNo'].includes(v2.prop)) { // 营业执照号/注册号
                        // 客户控制类型为空 / 非法人时，隐藏且清空；
                        v2.visible = (['1', '2'].includes(customerBodyType));
                    }
                    if (['idNumber'].includes(v2.prop)) {
                        v2.rule[0].required = customerBodyType === '0';
                        v2.visible = isVirtualCustomer !== 'Y' ? customerBodyType === '0' : isVirtualCustomer !== 'Y';
                        v2.type = customerBodyType === '0' ? 'custom' : 'input'; // 客户控制类型为法人时，显示且只读；
                    }
                    if (['ebcuTaxpayers', 'ebcuTaxpayersType'].includes(v2.prop)) { // 纳税登记人/纳税人类型
                        // 客户控制类型为空/非法人时，隐藏且清空；
                        v2.visible = isVirtualCustomer !== 'Y' && ['1', '2'].includes(customerBodyType);
                        v2.rule[0].required = customerBodyType === '1';
                        if (v2.prop === 'ebcuTaxpayersType') { // 纳税人类型
                            v2.type = ['1', '2'].includes(customerBodyType) && newPageStatus.value ? 'select' : 'custom'; // 客户控制类型为法人时，显示且必填；
                        }
                    }
                    if (['ebcuPlatformNature'].includes(v2.prop)) { // 企业性质
                        v2.type = newPageStatus.value ? 'select' : 'custom';
                        v2.visible = isVirtualCustomer !== 'Y';
                        v2.rule[0].required = newPageStatus.value;
                    }
                    if (['ebcuRegisteredCapital', 'businessScope'].includes(v2.prop)) {
                        // 客户控制类型为空/非法人时，隐藏且清空；
                        v2.visible = ['1', '2'].includes(customerBodyType) && isVirtualCustomer !== 'Y';
                    }
                    if (['ebcuEbplCountryCode', 'ebcuEbplProvinceCode', 'ebcuEbplCityCode', 'ebcuDistricts', 'addressCode'].includes(v2.prop)) {
                        v2.rule[0].required = newPageStatus.value;
                    }
                    if (['ebcuAddress'].includes(v2.prop)) { // 地址
                        v2.rule[0].required = newPageStatus.value;
                        v2.type = newPageStatus.value ? 'input' : 'custom';
                    }
                    // if (['ebcuEbplCountryCode'].includes(v2.prop)) {
                    //     // v2.type = customerBodyType === '2' ? 'select' : 'custom';
                    //     v2.type = customerBodyType === '2' ? 'select' : 'custom'; // 测试数据 删了, 要用上面的
                    // }
                    if (['ebcuRegistrationDate', 'regStatus', 'tycIndustry', 'staffNumRange', 'socialStaffNum', 'actualCapital', 'isMicroEnt', 'isCertification'].includes(v2.prop)) {
                        // 客户控制类型为空/非法人时，隐藏且清空；
                        v2.visible = isVirtualCustomer !== 'Y';
                    }
                    if (['isRelatedTransaction'].includes(v2.prop)) {
                        v2.rule[0].required = isVirtualCustomer === 'N';
                        v2.type = newPageStatus.value ? 'select' : 'custom';
                    }
                    if (['ouOrganizationName'].includes(v2.prop)) {
                        v2.rule[0].required = isRelatedTransaction === '1';
                        v2.type = newPageStatus.value && isRelatedTransaction === '1' ? 'advance' : 'custom';
                    }
                    if (['receiveByPos'].includes(v2.prop)) {
                        v2.type = isRelatedTransaction === '1' ? 'input' : 'custom';
                        v2.type = newPageStatus.value ? 'select' : 'custom';
                    }
                    if (['ebcuNameEn'].includes(v2.prop)) {
                        v2.type = newPageStatus.value ? 'input' : 'custom';
                        v2.rule[0].required = isVirtualCustomer !== 'Y' && customerBodyType?.toString() === '2'; // 新判断:判断客户控制类型为 海外 且非虚拟客户
                    }

                    if (opsUnlockData.value.includes(v2.prop)) {
                        v2.type = v2.opsUnlockType || 'custom';
                        v2.disabled = false;
                        return;
                        // ++isShowOpsUnlockKey.value;
                    }
                    // if (['2', '3'].includes(customerStatus?.toString())) {
                    //     // 当客户状态等于冻结/终止时，不允许保存； 直接就不可编辑
                    //     v2.type = 'custom';
                    //     return;
                    // }

                    // 次要字段：客户的审批状态等于客户审批中: 10 / 信息变更审批中: 20只读，否则保持可编辑状态；
                    if (['mainProducts', 'companyProfile', 'introduction', 'corporateCulture', 'companyUrl', 'ebcuTel', 'ebcuFax', 'ebcuEmail',
                        'ebcuZipCode', 'ebcuRemark'
                    ].includes(v2.prop)) {
                        v2.type = saveBtnApprovalStatus.includes(approvalStatus?.toString()) ? 'custom' : 'input';
                    }
                    // 关键字段：当客户的审批状态等于空/未审批:00/客户审批驳回:12时可编辑状态，否则保持只读；
                    if (!['', null, undefined, '0', '00', '12'].includes(approvalStatus?.toString())
                        && !['mainProducts', 'companyProfile', 'introduction', 'corporateCulture', 'companyUrl', 'ebcuTel', 'ebcuFax', 'ebcuEmail',
                            'ebcuZipCode', 'ebcuRemark'
                        ].includes(v2.prop)) {
                        v2.type = 'custom';
                    }
                    if (['ebcuRemark'].includes(v2.prop) && ['manageInfo'].includes(v.formName)) {
                        v2.visible = isVirtualCustomer === 'Y';
                    }
                    if (['3'].includes(mipStatus?.toString())) { // 流程审批中只读
                        v2.type = 'custom';
                    }
                    if (ebcuId && String(customerChannel) === '2') { // 流程审批中只读
                        v2.type = 'custom';
                    }
                    // if ((renewalFlowStatus && [3, 4].includes(+renewalFlowStatus)) || props.detailPageState === 'main'
                    //     || ['3', '4', '7'].includes(String(detailDataLocal.value.renewalChangeFlowStatus)) || (renewalChangeCreateUserCode && renewalChangeCreateUserCode !== userCode)) {
                    //     v2.disabled = true;
                    //     v2.type = 'custom';
                    // }
                });
            });
            return config;
        });
        // * 1：草稿；
        // * 2：待审批；
        // * 3：审批中；
        // * 4：审批通过；
        // * 5：审批驳回；
        // * 6：撤回；
        // * 7：作废
        // {"0":"新建","1":"有效","2":"冻结","3":"终止","4":"已审"}
        // 'customerChannel' =2 外部
        const isSaveBtnHandle = () => {
            const { customerChannel, customerStatus, approvalStatus, ebcuId } = detailDataLocal.value;
            if (opsUnlockData.value.length) return true;
            if (customerChannel?.toString() === '2' && ebcuId) return false; // 外部时, 已保存的不显示保存按钮
            return saveBtnApprovalStatus.includes(approvalStatus?.toString()) ? false : ['0', '1', '4'].includes(customerStatus?.toString()); // 审批状态等于客户审批中:10/信息变更审批中:20时，不显示 冻结终止不显示
        };
        // eslint-disable-next-line complexity
        const isShowBtn = computed(() => {
            const { customerChannel, customerStatus, isVirtualCustomer, originalGroupCode, societyCreditCode, ebcuId, crmCustomerId } = detailDataLocal.value;
            return {
                // customerStatus   NEW("0", "新建"),
                // save: !['3'].includes(detailDataLocal.value.mipStatus?.toString()), // 审批中不可保存
                // flow: detailDataLocal.value.customerStatus === '0' && detailDataLocal.value.customerCode
                //     && [null, undefined, '', '0', '1'].includes(detailDataLocal.value.mipStatus?.toString())
                // save: ['0', '1', '4'].includes(customerStatus?.toString()) || !saveBtnApprovalStatus.includes(approvalStatus?.toString()), // 可保存 && 内外渠=外部不显示
                // save: saveBtnApprovalStatus.includes(approvalStatus?.toString()) ? false : ['0', '1', '4'].includes(customerStatus?.toString()), // 审批状态等于客户审批中:10/信息变更审批中:20时，不显示 冻结终止不显示
                save: isSaveBtnHandle(),
                flow: ebcuId && ['0'].includes(customerStatus?.toString()) && customerChannel?.toString() !== '2', // 可提交审批
                infoChange: ebcuId && ['1', '4'].includes(customerStatus?.toString()), // 可信息变更
                statusChange: ebcuId, // 可状态变更
                insertSup: ebcuId && ['0', '1', '4'].includes(customerStatus?.toString()), // 可生成供应商
                insertVir: ebcuId && ['1'].includes(customerStatus?.toString()) && isVirtualCustomer !== 'Y', // 可新增虚拟客户
                asynGroup: ebcuId && ['1', '4'].includes(customerStatus?.toString()) && isVirtualCustomer !== 'Y' && !originalGroupCode, // 可同步集团
                asyncLaw: ebcuId && ['1'].includes(customerStatus?.toString()) && isVirtualCustomer !== 'Y', // 可同步法务
                updateBussiness: ebcuId && !!societyCreditCode, // 可更新工商信息
                getRiskLevel: ebcuId && !!societyCreditCode, //  获取风险等级
                opsUnlock: ebcuId, // 运维保存-指定客户管理员和IT管理员-菜单按钮权限控制
                opsSave: ebcuId, // 运维保存-指定客户管理员和IT管理员-菜单按钮权限控制
                xiaoshouyiPush: ebcuId,
                xsyLink: crmCustomerId,
                opsUpdate: true
            };
        });
        const showTabPage = computed(() => {
            return activeName.value;
        });
        const showSaveBtn = computed(() => {
            // const isCreater = detailDataLocal.renewalChangeFlowCreater === userCode;
            //  3 审批中 4 审批通过
            return ['3', '4'].includes(String(detailDataLocal.value.renewalFlowStatus));
        });
        const showEditBtn = computed(() => {
            const { renewalChangeCreateUserCode } = detailDataLocal.value;
            //  3 审批中 4 审批通过
            const isCreater = (renewalChangeCreateUserCode && renewalChangeCreateUserCode !== userCode);
            return ['3', '4', '7'].includes(String(detailDataLocal.value.renewalChangeFlowStatus)) || isCreater;
        });
        const regDetailPageState = ref('');
        watch(
            () => props.detailPageState, (val) => {
                regDetailPageState.value = val;
            },
            { deep: true, immediate: true }
        );

        const dictData = ref({});
        const detailLoading = ref(false);
        onMounted(async () => {
            // eslint-disable-next-line max-len
            const res = await getDictDataApi({ dictCodes: 'LMDM_CUSTOMER_CHANNEL,SYS_WM_CUSTOMER_STATUS,CRM_CONTRACT_RENEWAL_UPSTREAM,CRM_CONTRACT_RENEWAL_STATUS,CRM_CONTRACT_CAUSE_CATEGORIES,CRM_CONTRACT_CAUSE_SUBCATEGORY,CAUSE_CATEGORIES_TO_EXIT_STATUS,CAUSE_SUBCATEGORY_TO_CATEGORIES' });
            dictData.value = res.data;
            // fetchData();
        });
        const currentMipId = ref('');
        const cascaderKey = ref(1);
        const originalData = ref({});
        // const fetchData = _.debounce((val) => {
        const fetchData = (val) => {
            const { customerCode } = props.detailData;
            const params = {
                customerCode: val || customerCode || detailDataLocal.value.customerCode
            };
            if (!params.customerCode) return;
            detailLoading.value = true;
            return Promise.all([getCustomerByCode(params), getCustomerChangeFlowInfo(params)]).then(resArr => {
                // })
                // api(params).then(res => {
                let _data = {};
                if (+resArr[0].code === 0 && resArr[0].data) {
                    _data = resArr[0].data;
                }
                let mipData = {};
                if (+resArr[1].code === 0 && resArr[1].data) {
                    if (resArr[1].data.mipId && resArr[1].data.mipStatus?.toString() !== '7') {
                        currentMipId.value = resArr[1].data.mipId;
                        mipData = resArr[1].data;
                    }
                }
                detailDataLocal.value = {};
                _data = { ...resArr[0].data, ..._.pick(mipData, ['mipId', 'mipStatus', 'contractCode', 'mipUrl', 'customerChangeCode']) };
                originalData.value = formatData(_data);
                encryption.value = {};
                handleInfosChange({ form: formatData(_data) });
            }).catch(() => {
                detailLoading.value = false;
            }).finally(() => { detailLoading.value = false; });
            // eslint-disable-next-line no-magic-numbers
            // }, 200);
        };

        // 处理详情展示数据格式
        const formatData = (data) => {
            const newData = _.cloneDeep(data);
            !newData.file && (newData.file = []);
            const multipleKeys = ['customerLevel', 'businessType', 'warehouseType', 'riskCause'];
            multipleKeys.forEach(key => {
                if (Array.isArray(data[key])) {
                    newData[key] = data[key];
                } else if (data[key] && data[key].length) {
                    newData[key] = data[key].split(',');
                } else if (!data[key]) {
                    newData[key] = [];
                }
            });
            if (!Array.isArray(newData.industryType) && newData.industryCategoriesCode) {
                newData.industryType = [newData.industryCategoriesCode, newData.industryType];
            }
            newData.addressCode = generateAddressArray(data.ebcuEbplCountryCode, data.ebcuEbplProvinceCode, data.ebcuEbplCityCode, data.ebcuDistricts, data.ebcuTowns);
            return newData;
        };
        const generateAddressArray = (country, province, city, district, towns) => {
            const result = [];
            result.push(country);
            // 如果没有省级编码，直接返回空数组
            if (!province) {
                return result;
            }

            // 添加省级编码
            result.push(province);

            // 如果有市级编码，添加省市组合
            if (city) {
                result.push(city);

                // 如果有区级编码，添加省市区组合
                if (district) {
                    result.push(district);
                    if (towns) {
                        result.push(towns);
                    }
                }
            }

            return result;
        };

        const isHandleEdit = ref(false);
        // eslint-disable-next-line max-lines-per-function, complexity
        const handleInfosChange = (formObjData = {}) => { // 表单组件编辑回调，更新本地数据
            const { itemSetting, targetForm, refName } = formObjData;
            // 监控表单是否编辑过
            isHandleEdit.value = Boolean(itemSetting);
            if (!itemSetting) { // 页面初始化、刷新时走：
                detailDataLocal.value = Object.assign({}, formObjData.form);
                setupContext.root.$nextTick(() => {
                    setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
                    setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
                    setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value);
                });
                cascaderKey.value++;
            } else { // collapse组件编辑回调时走：
                if (itemSetting.prop === 'isRelatedTransaction') {
                    targetForm['ouOrganizationName'] = +targetForm['isRelatedTransaction'] === 1 ? targetForm['ouOrganizationName'] : '';
                    targetForm['ouOrganization'] = +targetForm['isRelatedTransaction'] === 1 ? targetForm['ouOrganization'] : '';
                } else if (itemSetting.prop === 'customerGroupName') { // 内外渠=纯外部时，客户系不能选泽美的系
                    if (targetForm['customerGroupCode'] === '01' && +detailDataLocal.value['customerChannel'] === 2) {
                        targetForm['customerGroupName'] = '';
                        targetForm['customerGroupCode'] = '';
                        Message.warning('内外渠=纯外部时，客户系不能选择美的系');
                    }
                } else if (['societyCreditCode', 'ebcuLegalEntity', 'ebcuTaxRegistNo', 'ebcuOrgBarcode', 'tycAddress'].includes(itemSetting.prop)) {
                    // 客户控制类型为空、非法人、海外客户时，隐藏且清空；
                    targetForm[itemSetting.prop] = ['', null, undefined, '0', '2'].includes(targetForm.customerBodyType) ? '' : targetForm[itemSetting.prop];
                } else if (['ebcuBusinessNo', 'ebcuTaxpayers', 'ebcuTaxpayersType'].includes(itemSetting.prop)) {
                    targetForm[itemSetting.prop] = ['', null, undefined, '0'].includes(targetForm.customerBodyType) ? '' : targetForm[itemSetting.prop];
                } else if (['sinosureCode'].includes(itemSetting.prop)) {
                    // 客户控制类型不为海外客户时，隐藏且清空；
                    targetForm[itemSetting.prop] = !['2'].includes(targetForm.customerBodyType) ? '' : targetForm[itemSetting.prop];
                } else if (['idNumber'].includes(itemSetting.prop)) {
                    // 客户控制类型为空、法人/个体户、海外客户时，隐藏且清空；
                    targetForm[itemSetting.prop] = ['', null, undefined, '1', '2'].includes(targetForm.customerBodyType) ? '' : targetForm[itemSetting.prop];
                } else if (['ebcuRegisteredCapital', 'businessScope'].includes(itemSetting.prop)) {
                    // 客户控制类型为空、非法人时，隐藏且清空；
                    targetForm[itemSetting.prop] = ['', null, undefined, '0'].includes(targetForm.customerBodyType) ? '' : targetForm[itemSetting.prop];
                } else if (['customerChannelRole'].includes(itemSetting.prop)) {
                    // 客户控制类型为空、非法人时，隐藏且清空；
                    targetForm['isSaleCompany'] = targetForm['customerChannelRole'] === '1' ? '1' : '0';
                    targetForm['isAgent'] = targetForm['customerChannelRole'] === '2' ? '1' : '0';
                    targetForm['isDistributor'] = targetForm['customerChannelRole'] === '3' ? '1' : '0';
                } else if (['customerName', 'customerShortName', 'ebcuNameEn'].includes(itemSetting.prop)) {
                    targetForm[itemSetting.prop] = targetForm[itemSetting.prop]?.trim() || '';
                }

                const { file } = detailDataLocal.value;
                // 除了插槽参数以外，其他参数取最新编辑的参数更新(因：插槽的编辑不会触发collapse组件change事件回调，因此change事件回调的插槽的参数是旧数据不能取)
                detailDataLocal.value = Object.assign(
                    {},
                    detailDataLocal.value,
                    formObjData.form,
                    targetForm,
                    { file } // 保证插槽数据用最新的
                );
                if (targetForm && refName) {
                    const targetColl = COLLAPSE.value.find(item => item.ref === refName); // 根据最新状态清空禁用的字段
                    if (targetColl && targetColl.formList) {
                        detailDataLocal.value = Object.assign(
                            {},
                            detailDataLocal.value,
                            targetForm,
                            { file } // 保证插槽数据用最新的
                        );
                        //  这里保存的时候会触发,保存的校验比这里重置的快的话,保存的时候就不会有异常错误提示
                        // eslint-disable-next-line max-depth
                        if (itemSetting) {
                            const timer = setTimeout(() => {
                                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
                                clearTimeout(timer);
                            });
                        }
                    }
                }
                // setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件

                // setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value);
            }
        };

        const setNumberType = (val) => {
            if (!_.isNil(val) && val !== '') {
                val = Number(val);
            }
            return val;
        };
        const numberList = ['contractScale', 'depositAmount', 'receivableAmount', 'overdueNoInvoicedAmount', 'overdueInvoicedAmount'];
        // 处理保存字段格式
        // eslint-disable-next-line complexity
        const saveDataFormat = (data) => {
            data.customerLevel && (data.customerLevel = data.customerLevel.join(','));
            data.businessType && (data.businessType = data.businessType.join(','));
            data.warehouseType && (data.warehouseType = data.warehouseType.join(','));
            data.riskCause && (data.riskCause = data.riskCause.join(','));
            numberList.forEach(it => {
                if (data.hasOwnProperty(it)) {
                    data[it] = setNumberType(data[it]);
                }
            });
            if (data.addressCode?.length) {
                data.ebcuEbplCountryCode = _.nth(data.addressCode, 0) ?? null;
                data.ebcuEbplProvinceCode = _.nth(data.addressCode, 1) ?? null;
                data.ebcuEbplCityCode = _.nth(data.addressCode, 2) ?? null;
                data.ebcuDistricts = _.nth(data.addressCode, 3) ?? null;
                data.ebcuTowns = _.nth(data.addressCode, 4) ?? null;
            }
            if (['', undefined].includes(data.bizRevId)) {
                data.bizRevId = null;
            }
            if (Array.isArray(data.industryType)) {
                data.industryTypeCode = data.industryType[1];
                data.industryType = data.industryType[1];
            }
            // if()
            return data;
        };
        const validateAddressRequired = (params) => {
            const { customerBodyType, isVirtualCustomer, ebcuEbplCountryCode, ebcuEbplProvinceCode, ebcuEbplCityCode } = params;
            if (isVirtualCustomer === 'Y') return true;
            const isAbroad = customerBodyType?.toString() === '2';
            const isDomestic = ['0', '1'].includes(customerBodyType?.toString());
            if (isAbroad) {
                if (!ebcuEbplCountryCode) {
                    Message.warning('海外/港澳台注册客户，国家不能为空');
                    return false;
                }
            } else if (isDomestic) {
                if (!ebcuEbplCountryCode) {
                    Message.warning('国家不能为空');
                    return false;
                }
                if (!ebcuEbplProvinceCode) {
                    Message.warning('省不能为空');
                    return false;
                }
                if (!ebcuEbplCityCode) {
                    Message.warning('市不能为空');
                    return false;
                }
            }
            return true;
        };
        const saveLoading = ref(false);
        const saveHeader = async (mipSubmit = false) => {
            if (!RegExp(noChineseReg).test(detailDataLocal.value.ebcuNameEn)) {
                return Message.warning('英文格式不对!');
            }
            const data = _.cloneDeep(setupContext.refs.upholdHealder.onsave());
            if (!data) return;
            const params = saveDataFormat(_.cloneDeep(detailDataLocal.value));
            if (!validateAddressRequired(params)) {
                saveLoading.value = false;
                return;
            }

            if (['', null, undefined].includes(data.teamType)) {
                params.teamType = null;
            } else {
                params.teamType = Number(data.teamType);
            }
            saveLoading.value = true;
            const saveApi = params.isPrivilege ? saveCustomerPrivilegeVerify : saveCustomer;
            return saveApi(params).then(res => {
                if (+res.code === 0) {
                    const tipsText = '';
                    if (mipSubmit === true) return; // 排除点击事件的event
                    // Message.success(`保存成功${tipsText}`);
                    comfirmDialog('保存成功' + tipsText, !!tipsText, res.data);
                } else {
                    saveLoading.value = false;
                    fetchData();
                }
                opsUnlockData.value = [];
            }).catch(() => {
                saveLoading.value = false;
                opsUnlockData.value = [];
                fetchData();
            });
        };
        // tipsText:提示文字,isMipUrl:true即滚动, true为有审批流
        const comfirmDialog = async (tipsText, isMipUrl, customerCode) => {
            const _oldData = _.cloneDeep(detailDataLocal.value);
            MessageBox.confirm(tipsText, `提示：`, {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                showCancelButton: false,
                type: 'success'
            }).then(async () => {
                fetchData(customerCode).then(() => {
                    !_oldData.customerCode && setupContext.emit('save-data', { ...detailDataLocal.value, customerCode }, props.detailPageState);
                });
                saveLoading.value = false;
            }).catch(async (action) => {
                saveLoading.value = false;
                fetchData(customerCode).then(() => {
                    !_oldData.customerCode && setupContext.emit('save-data', { ...detailDataLocal.value, customerCode }, props.detailPageState);
                });
            });
        };
        const editLoading = ref(false);

        // 判断当前页面的唯一iframe通信
        const isCurrentPage = computed(() => {
            const name = detailDataLocal.value.contractCode + detailDataLocal.value.companyCode + props.detailPageState;
            return props.activeTabs === name;
        });
        const btnloading = ref(false);

        const activeName = ref('1');
        const handleClickMoreInfo = (data) => { // 解决点击折叠/展开“更多信息”折叠筐，子页签编辑错位问题
            if (data.includes('moreInfo')) {
                handleClickTab({ name: activeName.value });
            }
        };
        const handleClickTab = (data) => {
            const editTabArr = ['iflowDetail'];
            if (editTabArr.includes(data.name)) { // 解决切换编辑表格时操作列错位问题
                nextTick(() => {
                    const tableRef = this.$refs[`${data.name}Ref`].$refs.editTableBox;
                    if (tableRef) {
                        tableRef.$refs.moduleTable.doLayout();
                    }
                });
            }
        };
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        // const toFlowHandle = (row) => {
        //     if (row.customerChangeCode) {
        //         jumpToFlow({ name: 'customerApplyFlow', query: { customerChangeCode: row.customerChangeCode } });
        //     } else {
        //         window.open(row.mipUrl, '_blank');
        //     }
        // };

        // 行业大类回调
        const customAppendChange = (val, prop) => {
            // detailDataLocal.value[prop] = val;
            if (val?.length) {
                detailDataLocal.value['industryCategoriesCode'] = getCaseListName(industryData.value, val)[0].industryCode;
                detailDataLocal.value['industryCategoriesName'] = getCaseListName(industryData.value, val)[0].industryName;
                detailDataLocal.value[prop] = val[1];
            } else {
                detailDataLocal.value['industryCategoriesCode'] = '';
                detailDataLocal.value['industryCategoriesName'] = '';
                detailDataLocal.value[prop] = '';
            }
            setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value);
        };
        const getCaseListName = (obj, pathArray) => {
            // 使用 Lodash 获取嵌套值
            const values = [];

            // 查找第一个ID匹配的对象
            let currentObj = _.find(obj, { industryCode: pathArray[0] });

            if (currentObj) {
                values.push(currentObj);

                // 遍历剩余的路径
                for (let i = 1; i < pathArray.length; i++) {
                    if (currentObj.children) {
                        currentObj = _.find(currentObj.children, { industryCode: pathArray[i] });
                        // eslint-disable-next-line max-depth
                        if (currentObj) {
                            values.push(currentObj);
                        }
                    } else {
                        // values.push('未找到');
                        break;
                    }
                }
            } else {
                // values.push('未找到');
            }

            return values;
        };
        // 行业大类数据
        const industryData = ref([]);
        const getIndustryTreeList = () => {
            return getIndustryTree({
                industryStatus: 1 // 0-停用、1-启用
            }).then(res => {
                if (res && +res.code === 0) {
                    industryData.value = res.data;
                }
            });
        };
        // 提交审批
        const flowLoading = ref(false);
        const flowHeader = () => {
            const { customerCode, mipStatus, customerChangeCode } = detailDataLocal.value;
            const params = { customerCode };
            if (!params.customerCode) {
                return Message.warning('请先保存客户信息');
            }
            // 有变更单号即跳审批页
            if (!_.isNil(mipStatus) && customerChangeCode) {
                jumpToFlow({ name: 'customerApplyFlow', query: { customerCode: customerCode, customerChangeCode: customerChangeCode } });
                return;
            }
            flowLoading.value = true;
            customerSubmitFlow(params).then(async res => {
                if (res && +res.code === 0) {
                    jumpToFlow({ name: 'customerApplyFlow', query: { customerCode: detailDataLocal.value.customerCode, customerChangeCode: res.data.contractCode } });
                    const res2 = await getCustomerChangeFlowInfo(params);
                    let mipData = {};
                    if (res2 && +res2.code === 0 && res2.data) {
                        if (res2.data.mipId && res2.data.mipStatus?.toString() !== '7') {
                            currentMipId.value = res2.data.mipId;
                            mipData = res2.data;
                        }
                    }
                    const _data = { ...detailDataLocal.value, ..._.pick(mipData, ['mipId', 'mipStatus', 'contractCode', 'mipUrl', 'customerChangeCode']) };
                    handleInfosChange({ form: formatData(_data) });
                } else {
                    setFlowCheckHandle(res);
                }
            }).finally(() => {
                flowLoading.value = false;
            });
        };
        const setFlowCheckHandle = res => {
            if (res.msg.indexOf('业务实体') > -1) {
                activeName.value = 'ebca';
                scrollToHandle();
            } else if (res.msg.indexOf('联系人') > -1) {
                activeName.value = 'contact';
                scrollToHandle();
            } else if (['流程', '变更', '在途的虚拟客户', '审批', '请先闭环'].some(it => res.msg.indexOf(it) > -1)) {
                activeName.value = 'iflowDetail';
                scrollToHandle();
            }
        };
        const scrollToHandle = () => {
            const { customerCode } = detailDataLocal.value;
            const elementRules = document.querySelector(`.${customerCode}${props.detailPageState}`);
            const collapseRules = document.querySelector(`.customer-content-detail`);
            setupContext.root.$nextTick(() => {
                elementRules.scrollTo({
                    // eslint-disable-next-line no-magic-numbers
                    top: collapseRules.getBoundingClientRect().height || 1200,
                    left: 0,
                    behavior: 'smooth' // 可选值：'auto'（默认）或'smooth'（平滑滚动）
                });
            });
        };
        // 地址选择回调
        const addressChange = (form, col, type) => {
            detailDataLocal.value.addressCode = form.addressCode;
            setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value);
            if (form.addressCode && form.addressCode.length > 0) {
                setupContext.root.$nextTick(() => {
                    // 获取当前选中的节点信息
                    const selectedNodes = setupContext.refs.customerAddressRef.getCheckedNodes();
                    if (selectedNodes.length > 0) {
                        const currentNode = selectedNodes[0];
                        // 判断当前节点是否还有子节点（非叶子节点）
                        if (currentNode.hasChildren || !currentNode.isLeaf) {
                            // 方法：通过DOM操作模拟点击，展开下一级
                            triggerNodeExpand();
                        }
                    }
                });
            }
        };
        // 部分浏览器多次下拉出现页面卡死问题处理
        const visibleChange = () => {
            setupContext.root.$nextTick(() => {
                // 添加这段代码
                const $el = document.querySelectorAll('.el-cascader-panel .el-cascader-node[aria-owns]');
                Array.from($el).forEach(item => item.removeAttribute('aria-owns'));
            });
        };
        const triggerNodeExpand = () => {
            // 找到当前选中的单选框元素
            const checkedRadios = document.querySelectorAll('.address-popper-custom .el-radio.is-checked');
            if (checkedRadios.length > 0) {
                // 通常最后一个是最新选中的
                const lastCheckedRadio = checkedRadios[checkedRadios.length - 1];
                // 找到相邻的用于展开的箭头图标或元素并点击
                const expandIcon = lastCheckedRadio.nextElementSibling;
                if (expandIcon && expandIcon.click) {
                    expandIcon.click();
                }
            }
        };
        const checkChangeList = {
            1: checkVirtualInfo,
            2: checkChangeInfo,
            3: checkStatusInfo
        };
        const checkLoading = ref({
            checkLoading1: false,
            checkLoading2: false,
            checkLoading3: false,
            checkLoading4: false
        });
        const changeTips = {
            2: '外部客户建议在销售易提交客户信息变更申请！',
            3: '外部客户建议在销售易提交客户状态变更申请！'
        };
        const addOverseas = async () => {
            try {
                // 子标签页定位到海外业务引入
                activeName.value = 'overseasIntroduction';
                if (['2', '3'].includes(detailDataLocal.value.customerStatus)) {
                    Message.error('客户状态终止/冻结，禁止引入');
                    return;
                }
                // 根据状态查询列表，有未审批通过的不能新增，定位到海外合同标签页
                await getCustomerIntroductionPage({ customerCode: detailDataLocal.value.customerCode, approvalStatusList: ['1', '2', '3', '5', '6'] }).then(res => {
                    if (res && res.totalCount === 0) {
                        ctx.$router.push({
                            name: 'customerIntroductionChangeFlow',
                            query: {
                                type: 'add',
                                customerCode: detailDataLocal.value.customerCode
                            }
                        });
                    } else {
                        scrollToHandle();
                    }
                });
            } catch (error) {
                checkLoading.value.checkLoading4 = false;
            }
        };
        const infoChangeHeader = async (type) => {
            const { customerChannel, isVirtualCustomer, isImpExpCustomer, customerCode } = detailDataLocal.value;

            if (!customerCode) {
                return Message.warning('暂时无客户,请先保存再操作!');
            }
            if (typeof checkChangeList[type] !== 'function') {
                return Message.warning('变更类型错误!');
            }
            // 点击时，当”内外渠=纯外部2、是否虚拟客户=否N、内外销=内销0“时增加二次弹框提醒
            if (changeTips[type] && customerChannel?.toString() === '2' && isVirtualCustomer?.toString() === 'N' && isImpExpCustomer?.toString() === '0') {
                const hasShowConfirmPermission = otherUtils.getHasAuth(authorityCode.showConfirmButton);
                MessageBox.confirm(changeTips[type], '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    showConfirmButton: hasShowConfirmPermission,
                    type: 'warning'
                }).then(() => {
                    openChangeDetail(type);
                }).catch(res => {
                });
            } else {
                openChangeDetail(type);
            }
        };
        const openChangeDetail = async (type) => {
            try {
                let params = {
                    customerCode: detailDataLocal.value.customerCode
                };
                if (+type === 1) {
                    params = {
                        belongCustomerCode: detailDataLocal.value.customerCode
                    };
                }
                const checkApi = checkChangeList[type];
                checkLoading.value['checkLoading' + type] = true;
                const res = await checkApi(params);
                if (res && +res.code === 0) {
                    jumpToFlow({ name: 'customerChangeFlow', query: { customerChangeType: type, customerCode: detailDataLocal.value.customerCode } });
                    Bus.$emit('customerInfoChange', { customerCode: detailDataLocal.value.customerCode });
                } else if (['流程', '变更', '在途的虚拟客户', '审批', '请先闭环'].some(it => res.msg.indexOf(it) > -1)) {
                    activeName.value = 'iflowDetail';
                    scrollToHandle();
                }
                checkLoading.value['checkLoading' + type] = false;
            } catch (error) {
                checkLoading.value['checkLoading' + type] = false;
            }
        };
        // 跳转至流程
        const jumpToFlow = (data) => {
            ctx.$router.push(data);
            bigDataLog.sendDetailMessageByKey(`bigData-page-customer-flow-${data.name}`);
        };

        const insertSupLoading = ref(false);
        const insertSupHeader = () => {
            const params = {
                systemSource: 'CRM',
                customerCode: detailDataLocal.value.customerCode
            };
            if (!detailDataLocal.value.customerCode) return Message.warning('暂时无客户,请先保存再操作!');
            insertSupLoading.value = true;
            insertSupCustomer(params).then(res => {
                if (res && +res.code === 0) {
                    insertSupLoading.value = false;
                    Message.success('生成供应商成功');
                    fetchData();
                }
            }).finally(() => {
                insertSupLoading.value = false;
            });
        };

        const asyncGroupLoading = ref(false);
        const asynGroupcHeader = () => {
            // const params = {
            //     customerCode:
            // };
            if (!detailDataLocal.value.customerCode) return Message.warning('暂时无客户,请先保存再操作!');
            asyncGroupLoading.value = true;
            asyncGroupCustomer([detailDataLocal.value.customerCode]).then(res => {
                if (res && +res.code === 0) {
                    asyncGroupLoading.value = false;
                    Message.success('同步集团成功');
                    fetchData();
                }
            }).finally(() => {
                asyncGroupLoading.value = false;
            });
        };
        const asyncLawLoading = ref(false);
        const asyncLawHeader = () => {
            // const params = {
            //     customerCode:
            // };
            if (!detailDataLocal.value.customerCode) return Message.warning('暂时无客户,请先保存再操作!');
            asyncLawLoading.value = true;
            asyncLawCustomer([detailDataLocal.value.customerCode]).then(res => {
                if (res && +res.code === 0) {
                    asyncLawLoading.value = false;
                    Message.success('同步法务成功');
                    fetchData();
                }
            }).finally(() => {
                asyncLawLoading.value = false;
            });
        };
        const updateBussinessHeader = () => {
            bigDataLog.sendDetailMessageByKey('bigData-btn-customer-detail-updateBussiness');
            const params = {
                enterpriseCode: detailDataLocal.value.customerCode
            };
            if (!detailDataLocal.value.customerCode) return Message.warning('暂时无客户,请先保存再操作!');
            MessageBox.confirm(`按统一社会信用代码更新客户的工商信息？`, {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                updateBussinessCustomer(params).then(res => {
                    if (res && +res.code === 0) {
                        Message.success('更新工商信息成功');
                        fetchData();
                    }
                });
            }).catch(() => { });
        };
        const getRiskLevelLoading = ref(false);
        const getRiskLevelHeader = () => {
            bigDataLog.sendDetailMessageByKey('bigData-btn-customer-detail-getRiskLevel');
            const params = {
                customerCode: detailDataLocal.value.customerCode
            };
            if (!detailDataLocal.value.customerCode) return Message.warning('暂时无客户,请先保存再操作!');
            getRiskLevelLoading.value = true;
            getRiskLevelCustomer(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('获取风险等级成功');
                    fetchData();
                    getRiskLevelLoading.value = false;
                }
            }).finally(() => {
                getRiskLevelLoading.value = false;
            });
        };
        const opsUnlockLoading = ref(false);
        const opsUnlockData = ref([]);
        const opsUnlockHeader = () => {
            bigDataLog.sendDetailMessageByKey('bigData-btn-customer-detail-opsUnlock');
            const params = {
                userCode: userCode
            };
            if (!userCode) return Message.warning('暂时无用户,请重新登录!');
            opsUnlockLoading.value = true;
            opsUnlockCustomer(params).then(res => {
                if (res && +res.code === 0) {
                    if (!Object.keys(res.data).length) {
                        return Message.warning('当前用户不是特权人,请联系管理员添加特权人再进行解锁!');
                    }
                    Message.success('运维解锁成功,请编辑');
                    opsUnlockLoading.value = false;
                    opsUnlockData.value = res.data?.enableFieldList?.map(it => {
                        it = it.replace(/_([a-z])/g, (_, char) => char.toUpperCase()); // 下横线替换成大写
                        return it;
                    }) || [];
                    setupContext.root.$nextTick(() => {
                        setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
                    });
                }
            }).finally(() => {
                opsUnlockLoading.value = false;
            });
        };
        const xiaoshouyiPushLoading = ref(false);
        const xiaoshouyiPushHeader = () => {
            bigDataLog.sendDetailMessageByKey('bigData-btn-customer-detail-xiaoshouyiPush');
            const params = {
                customerCodeList: [detailDataLocal.value.customerCode]
            };
            if (!detailDataLocal.value.customerCode) return Message.warning('暂时无客户可以重推!');
            xiaoshouyiPushLoading.value = true;
            xsyPush(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('销售易推送成功');
                    fetchData();
                    xiaoshouyiPushLoading.value = false;
                }
            }).finally(() => {
                xiaoshouyiPushLoading.value = false;
            });
        };
        const opsUpdateHeader = () => {
            const { originalGroupCode, customerCode } = detailDataLocal.value;
            if (!originalGroupCode) { return Message.warning('当前客户无集团编码'); }
            setupContext.refs.customerErpRef.show({ customerCode }); // 接口请求参数
        };

        const openXsyLink = () => {
            const { crmCustomerId } = detailDataLocal.value;
            const _url = configEnv.xiaoshouyiUrl + `/bff/neoweb#/entityDetail/account/${crmCustomerId}?objectApiKey=account&recordId=${crmCustomerId}`;
            window.open(_url, '_blank');
        };

        const refleshPage = () => {
            opsUnlockData.value = [];
            fetchData();
        };
        // 获取客户状态
        const getCustomerStatus = () => {
            if (dictData.value.SYS_WM_CUSTOMER_STATUS) {
                return dictData.value.SYS_WM_CUSTOMER_STATUS[detailDataLocal.value.customerStatus];
            }
        };
        // 获取虚拟客户信息
        const getVirtualCustomerStatus = () => {
            const { belongCustomerName, belongIndustryTypeName, belongIndustryCategoriesName, belongCustomerChannel } = detailDataLocal.value;
            const customerChannelCn = _.get(dictData.value.LMDM_CUSTOMER_CHANNEL, belongCustomerChannel);
            if (belongCustomerName && belongIndustryTypeName && belongIndustryCategoriesName && customerChannelCn) {
                return `主客户信息：${belongCustomerName}${belongIndustryTypeName}，行业：${belongIndustryCategoriesName}，内外渠：${customerChannelCn}`;
            }
        };
        // 格式化地址
        const formatAddress = () => {
            const { ebcuEbplCountryName, ebcuEbplProvinceName, ebcuEbplCityName, ebcuDistrictsName, ebcuTownsName } = detailDataLocal.value;
            const adddresList = [ebcuEbplCountryName, ebcuEbplProvinceName, ebcuEbplCityName, ebcuDistrictsName, ebcuTownsName];
            const _text = adddresList.filter(it => it).join('/');
            return _text || '--';
        };
        // 加密身份证
        const formatIdNumber = (val) => {
            if (!detailDataLocal.value.ebcuId) return val;
            return desensitization.idCard(val);
        };
        // 格式化行业大类/细分行业
        const formatIndustry = () => {
            return detailDataLocal.value.industryTypeName || '--';
        };
        // 格式化显示地址中文名, 英文名, 本国语 判断与中文一致不展示
        const formatCascaderData = data => {
            return (data.nameCn || data.nameEn);
        };

        const showTooltip = ref(false);
        const mouseenterHandle = e => {
            if (e.target.clientWidth < e.target.scrollWidth) {
                showTooltip.value = false;
            } else {
                showTooltip.value = true;
            }
        };
        const openOtherCustomer = (row) => {
            setupContext.emit('other-change', row.customerCode);
        };
        const addressFilter = (node, keyword) => {
            // 如果关键词为空，则显示所有选项
            if (!keyword) return true;

            // 将节点文本和搜索词都转为大写后进行匹配
            // 使用 node.text 还是 node.label 取决于你数据中配置的字段名
            const nodeText = node.text || node.label || '';
            const upperNodeText = nodeText.toUpperCase();
            const upperKeyword = keyword.toUpperCase();
            if (upperNodeText.indexOf(upperKeyword) > -1) {
                return true;
            }
            const nameEnText = node.data.nameEn?.toUpperCase();
            const nameLoText = node.data.nameLo?.toUpperCase();
            if (nameEnText.indexOf(upperKeyword) > -1) {
                return true;
            }
            // 如果匹配成功，返回 true
            if (nameLoText.indexOf(upperKeyword) > -1) {
                return true;
            }
            return false;
        };
        const encryption = ref({
            idNumber: false
        });
        const handleChangeText = (item) => {
            encryption.value[item.prop] = !encryption.value[item.prop];
            setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
        };
        // 对应加密方法
        const menuList = {
            idNumber: 'idCard'
        };
        const encryptionHandle = (val, p) => {
            const { desensitization } = otherUtils;
            const prop = menuList[p];
            if (!desensitization[prop]) return '';
            if (encryption.value[p]) return val;
            return desensitization[prop](val);
        };

        // 组件卸载时，取消订阅
        onUnmounted(() => {
            Bus.$off('customerInfoChange');
        });
        watch(
            () => [props.detailData, props.detailPageState],
            (newVal) => {
                initCustomerKey = 1;
                activeName.value = '1';
                getIndustryTreeList();
                if (props.detailPageState === 'new') {
                    handleInfosChange({ form: formatData(props.detailData) });
                    return;
                }
                if (props.detailPageState && props.detailData) {
                    fetchData();
                }
            },
            { deep: true, immediate: true }
        );
        return {
            authorityCode,
            detailLoading,
            saveLoading,
            activeCollapses,
            detailDataLocal,
            COLLAPSE,
            regDetailPageState,
            showTabPage,
            btnloading,
            isCurrentPage,
            currentMipId,
            industryData,
            newPageStatus,
            isShowBtn,
            showSaveBtn,
            showEditBtn,
            activeName,
            readonly,
            editLoading,
            flowLoading,
            collapseKeys,
            opsUnlockLoading,
            getRiskLevelLoading,
            asyncLawLoading,
            asyncGroupLoading,
            insertSupLoading,
            dictData,
            subTabShow,
            industryTypeDisabled,
            addressCodeDisabled,
            cascaderKey,
            showTooltip,
            isShowMoreBtn,
            checkLoading,
            xiaoshouyiPushLoading,
            addedDictKeys,
            addressFilter,
            originalData,
            iconCloseEyes,
            iconOpenEyes,
            encryption,
            visibleChange,
            handleChangeText,
            encryptionHandle,
            addOverseas,
            openOtherCustomer,
            openXsyLink,
            refleshPage,
            opsUpdateHeader,
            xiaoshouyiPushHeader,
            getVirtualCustomerStatus,
            mouseenterHandle,
            formatCascaderData,
            formatIdNumber,
            formatIndustry,
            formatAddress,
            getCustomerStatus,
            infoChangeHeader,
            insertSupHeader,
            asynGroupcHeader,
            asyncLawHeader,
            updateBussinessHeader,
            getRiskLevelHeader,
            opsUnlockHeader,
            handleInfosChange,
            saveHeader,
            flowHeader,
            handleClickMoreInfo,
            handleClickTab,
            customAppendChange,
            addressChange
        };
    }
};
</script>
<style lang="less" scoped>
.customer-cascader-select {
    width: 100%;
}

.customer-head-right {
    display: flex;
    align-items: center;
}

.customer-head-more {
    height: 28px;
}

.customer-detail-page {
    .customer-head-box {
        position: sticky;
        top: 0;
        z-index: 100;
        background: #fff;
        padding-bottom: 11px;
        border-bottom: 1px solid #EBEEF5;
        box-sizing: border-box;
    }

    .customer-head {
        font-size: 18px;
        padding: 8px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-right: 8px;

        .customer-head-title {
            max-width: 400px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .customer-head-left {
            display: flex;
        }

        .customer-status {
            font-size: 12px;
            padding: 4px 8px;
            color: #ffffff;
            border-radius: 10px;
            margin-left: 8px;
        }

        .customer-0 {
            background: #f2761f;
        }

        .customer-1 {
            background: #6AE7B0;
        }

        .customer-2 {
            background: #999999;
        }

        .customer-3 {
            background: #f44040;
        }

        .customer-4 {
            background: #4285f5;
        }

    }

    .customer-Y {
        color: #fff;
        font-size: 12px;
        padding: 4px 8px;
        border-radius: 10px;
        background: #B668FF;
    }

    .customer-text-area {
        color: #606266;
        white-space: pre-wrap;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        margin-top: 6px;
        line-height: 1.2;
    }

    .address-custom {
        width: 100%;
    }
    .text-eyes {
        width: 14px;
        margin-left: 4px;
        cursor: pointer;
        position: relative;
        top: 2px;
    }
    .customer-id-number{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>
<style lang="less">
.customer-detail-page {
    .file-infos {
        width: 100%;
        padding: 0 10px 0 0;

        .file-list {
            width: 100%;
            padding: 2px 0 2px 4px;
            display: flex;

            // justify-content: space-between;
            .file-name {
                // flex: 1;
                width: 500px;
                padding-right: 5px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                display: inline-block;
            }

            .view-btn,
            .delete-btn {
                width: 200px;
                display: flex;

                a {
                    text-decoration: none;
                    color: #4285F5;
                }

                .el-button {
                    margin-left: 10px;
                }

                .el-button:focus,
                .el-button:hover,
                .el-button:active,
                .el-button.is-disabled {
                    outline: none !important;
                    border-color: transparent !important;
                    /* 可选：如果要去除激活时的边框颜色变化 */
                }
            }
        }
    }

    .reg-head {
        position: sticky;
        z-index: 999;
        background-color: #fff;
        top: 0;
    }

    .detail-toolBar {
        display: flex;
        align-content: center;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 26px;

        .btn-head {
            height: 40px;
            line-height: 40px;

        }
    }

    .header-operation {
        margin-top: 16px;
    }

    .ifr {
        width: 100%;
        height: 100vh;
        border: none;
    }

}

.address-popper-custom {

    .cascader-custom {
        display: flex;
        justify-content: space-between;

        p {
            flex: 1;
            margin: 0 5px;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            min-width: 35px;
            max-width: 90px;
        }
    }
}

.resg-mip-link {
    text-decoration: none;
    cursor: pointer;
    color: #4285F5;
    width: 100%;
    display: inline-block;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.change-status {

    // width: 100%;
    // display: flex;
    // justify-content: flex-end;
    .change-title {
        color: #888;
    }

    .change-mr {
        display: inline-block;
        margin-right: 16px;
        color: #f56c6c;
    }
}
</style>
